export const snapScrollToRows = (scroller: HTMLElement) => {
	const handleWheel = (event: WheelEvent) => {
		if (event.ctrlKey || event.deltaY === 0) return;

		const row = scroller.querySelector<HTMLElement>(".MuiDataGrid-row");
		if (!row) return;

		const rowHeight = row.getBoundingClientRect().height;
		if (rowHeight <= 0) return;

		const current = scroller.scrollTop;
		const maxScroll = scroller.scrollHeight - scroller.clientHeight;
		const aligned = Math.round(current / rowHeight) * rowHeight;

		const target = Math.min(
			maxScroll,
			Math.max(0, aligned + Math.sign(event.deltaY) * rowHeight),
		);
		if (target === current) return;

		event.preventDefault();
		scroller.scrollTop = target;
	};

	scroller.addEventListener("wheel", handleWheel, { passive: false });

	return () => scroller.removeEventListener("wheel", handleWheel);
};
